<template>
  <div class="myChart" :id="parent_id">

      <canvas :id="chart_id" style="width:100%; height:100%;"></canvas>


  </div>
</template>


<style scoped>

  .myChart{
    width: 100%;
    height: 100%;
  }
</style>


<script>

  //https://vue-chartjs.org/guide/#vue-single-file-components
  //  import { Line, mixins } from 'vue-chartjs';
  //  const { reactiveProp } = mixins;


  import echarts from 'echarts';

  // let ctx = document.getElementById('myChart');


   export default {
      name: "timeseries",
      props: {
         chartdata: Object,
         clickHandler:  Function,
      },

      data(){
        return {
           chart_id: null,
           myChart: null,

           // data: {
           //    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
           //    datasets: [{
           //       label: 'My First dataset',
           //       data: [
           //          3,
           //          5,
           //          7,
           //          2,
           //          8,
           //          4,
           //          5,
           //       ],
           //       fill: false,
           //    }, {
           //       label: 'My Second dataset',
           //       fill: false,
           //       data: [
           //          5,
           //          7,
           //          2,
           //          8,
           //          4,
           //          5,
           //          3
           //       ],
           //    }]
           // },





        }
      },

      methods: {
        renderChart(){

           // see this article for fixing blurry canvas renderings
           //https://stackoverflow.com/questions/15661339/how-do-i-fix-blurry-text-in-my-html5-canvas

           console.log('I ran', this.chartdata)

           var canvas = document.getElementById(this.chart_id);
           let ctx = canvas.getContext('2d');
           let dpi = window.devicePixelRatio;
           // dpi=3;

           //get element dimensions
           let style_height = +getComputedStyle(canvas).getPropertyValue("height").slice(0, -2);
           let style_width = +getComputedStyle(canvas).getPropertyValue("width").slice(0, -2);

           // console.log('h x w', style_height, style_width);

           // console.log(canvas.getAttribute('height'))
           //scale the canvas

           let height = style_height * dpi;
           let width = style_width * dpi;

           // canvas.setAttribute('height', height);
           // canvas.setAttribute('width', width);

           // canvas.setAttribute('height', style_height );
           // canvas.setAttribute('width', style_width );

           this.myChart = echarts.init(document.getElementById(this.chart_id), {}, {renderer: 'canvas', devicePixelRatio: dpi});

           this.myChart.resize({width: style_width, height: style_height });

           // myChart.resize({width: width, height: height });


           // console.log('this.myClickHandler', this.test)
           this.myChart.setOption(this.chartdata, {notMerge: true});


           let callback = this.clickHandler;
           if (callback !== undefined){
              this.myChart.on('click', function (params) {

                 callback(params);
              })
           }


           // console.log('pixelratio', myChart.getDevicePixelRatio());
           // console.log('echart', myChart)
        },

         resize_chart(){


            let canvas = document.getElementById(this.parent_id);

            //get element dimensions
            let style_height = +getComputedStyle(canvas).getPropertyValue("height").slice(0, -2);
            let style_width = +getComputedStyle(canvas).getPropertyValue("width").slice(0, -2);
            console.log('Resize EVENT', this.chart_id,style_height, style_width )
            this.myChart.resize({width: style_width, height: style_height });
         }

      },

      watch:{
         chartdata(newVal, oldVal){

           this.renderChart();
        }
      },

      created(){
         this.chart_id = 'myChart-' + this._uid;
         this.parent_id = 'myChartDiv-' + this._uid;
      },
      mounted() {

         window.addEventListener("resize", this.resize_chart);

         this.renderChart();
      },
      beforeDestroy() {
         window.removeEventListener("resize", this.resize_chart);
      },
   }
</script>

